<div class="table-wrapper">
  <table>
    <thead>
    <tr>
      <th *ngFor="let header of headers" (click)="sort(header)">
        {{ header.title }}
        <span *ngIf="!header.edit && header.sortable !== false">
            <ng-container *ngIf="currentSort == '' || currentSortHeader != header.key">
              <app-icon [icon]="Icons.sortNone" [width]="16" [height]="16"/>
            </ng-container>
            <ng-container *ngIf="currentSort == 'asc' && currentSortHeader == header.key">
              <app-icon [icon]="Icons.sortUp" [width]="16" [height]="16"/>
            </ng-container>
            <ng-container *ngIf="currentSort == 'desc' && currentSortHeader == header.key">
              <app-icon [icon]="Icons.sortDown" [width]="16" [height]="16"/>
            </ng-container>
          </span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of data" (click)="openItemRow(row)">
      <td *ngFor="let header of headers" [style.width]="header.width || 'auto'">
        <div *ngIf="header.img" class="image-text-container">
          <img
            *ngIf="row['image'] || row['url']"
            [src]="getImageUrl(row['image'] || row['url'])"
            loading="lazy"
            width="100"
            height="auto"
            style="max-width: 100px; max-height: 60px; object-fit: cover; border-radius: 4px;"
          >
          <span class="content-cell">
              {{ getCellValue(row, header) }}
            </span>
        </div>

        <span *ngIf="!header.img && !header.edit" class="content-cell">
            {{ getCellValue(row, header) }}
          </span>

        <div *ngIf="header.edit" class="icon-open-item">
          <app-icon [icon]="Icons.squareArrow" (click)="openItem($event, row)"/>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
